import { useTranslation } from 'react-i18next';
import { Form, Icon, Page } from '@/components';
import {
  AnnouncementEditPanel,
  AnnouncementFormValues,
} from '@/views/Announcements.Details';
import { Button, Space } from 'antd';
import { AdminTabKeys } from '@/views/Admin/AdminTabs';
import { useNavigate } from 'react-router-dom';
import { useAddAnnouncementMutation } from '@/redux/announcements';
import { useCallback } from 'react';

export function AnnouncementAddPage() {
  const { t } = useTranslation();
  const title = t('announcements.add');
  const [add] = useAddAnnouncementMutation();
  const push = useNavigate();
  const backRoute = `/admin#${AdminTabKeys['announcements']}`;

  const handleAdd = useCallback(
    (value: AnnouncementFormValues) => {
      add({
        ...value,
        startDate: value.startDate.utc().startOf('day').toISOString(),
        endDate: value.endDate?.utc().toISOString(),
      });
      push(-1);
    },
    [add, push],
  );

  return (
    <Page htmlTitle={title}>
      <Page.Paths>
        <Page.Path href={backRoute}>{t('announcements.title')}</Page.Path>
        <Page.Path>{title}</Page.Path>
      </Page.Paths>

      <Page.Body>
        <Page.Card
          title={title}
          icon={<Icon type="announcement" />}
          color="#814A93"
          actions={
            <Space size="middle">
              <Button onClick={() => push(backRoute)}>{t('cancel')}</Button>
              <Form.Submit uid="announcement-details" type="primary">
                {t('save')}
              </Form.Submit>
            </Space>
          }
        >
          <AnnouncementEditPanel onSubmit={handleAdd} />
        </Page.Card>
      </Page.Body>
    </Page>
  );
}
